var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMissed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36722 6.49589C3.24927 6.54469 3.13877 6.61703 3.04289 6.71291C2.84763 6.90817 2.75 7.16409 2.75 7.42001V12.92C2.75 13.4723 3.19772 13.92 3.75 13.92C4.30228 13.92 4.75 13.4723 4.75 12.92V9.83423L12.2096 17.2938C12.6001 17.6843 13.2332 17.6843 13.6238 17.2938L20.9571 9.96045C21.3476 9.56993 21.3476 8.93676 20.9571 8.54624C20.5666 8.15572 19.9334 8.15572 19.5429 8.54624L12.9167 15.1725L6.16421 8.42001H9.25C9.80228 8.42001 10.25 7.9723 10.25 7.42001C10.25 6.86773 9.80228 6.42001 9.25 6.42001H3.75C3.61441 6.42001 3.48512 6.447 3.36722 6.49589Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMissed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Missed.25f667c92579e5ede83431566969c559.svg";